/**
 * TASK-028 guard rail.
 *
 * Every evaluation endpoint is nested under `/rfx/{rfxId}/...`. When `rfxId` was
 * derived from a not-yet-loaded (or permanently 403'd) `rfxData`, the template
 * literal stringified `undefined` and we shipped a request to
 * `/rfx/undefined/evaluation/17/panel-members/25/disclaimer` — which the API
 * answers with a confusing "route could not be found" 404 rather than anything
 * that points at the real cause.
 *
 * Mutations call this so a missing id fails immediately, loudly, and with a
 * message that names the culprit. Queries should instead stay disabled via
 * `enabled: !!rfxId`, since a query firing early is normal and not an error.
 *
 * @throws Error when the id is not usable in a URL.
 */
export const requireRfxId = (
	rfxId: number | null | undefined,
	action: string
): number => {
	if (rfxId === null || rfxId === undefined || Number.isNaN(rfxId)) {
		throw new Error(
			`Cannot ${action}: the RFx id is not available yet. ` +
				"Derive it from `useEvaluationRfxId()` (URL-seeded), not `rfxData?.id`."
		);
	}

	return rfxId;
};
